<template>
	<canvas ref="ruleCanvas" v-bind:width="width" v-bind:height="height" style="background-color:rgba(0, 0, 0, 0.13)" />
</template>

<script>
	import { store } from './store'
	export default {
		props: {
			width: {
				type: Number,
				required: true,
			},
			height: {
				type: Number,
				required: true,
			},
		},
		data() {
			return {
				canvas: null,
				hex: 1,
			}
		},
		computed: {
			/**
			 * 批次长度
			 */
			length() {
				return store.state.totalLength
			},
			/**
			 * 缺陷点记录。
			 */
			pointsData() {
				var defects = store.state.filteredDefects
				var data = defects
					.map(p => p.meter / 1000)
					.sort((a, b) => {
						return a - b
					})

				return data
			},
		},
		watch: {
			/**
			 * 监控缺陷点数据。
			 */
			pointsData: {
				handler(data) {
					if (data.length > 0) {
						console.log(this)
						this.drawData(data)
					}
				},
				deep: true,
			},
			/**
			 * 监控批次长度。
			 */
			length(val) {
				this.drawHorizontalAxisTicks()

				var ctx = this.canvas.getContext('2d')
				ctx.strokeStyle = '#8bff65'
				ctx.lineWidth = 1
				ctx.moveTo(0 + 0.5, this.height / 1.6 + 0.5)
				ctx.lineTo(this.width + 0.5, this.height / 1.6 + 0.5)
				ctx.stroke()
			},
		},
		methods: {
			/**
			 * 绘制密度。
			 */
			drawData(array) {
				var y = this.height / 1.6
				var ctx = this.canvas.getContext('2d')

				//清空已绘制的标记,只清空上半部分。
				ctx.clearRect(0, -(this.height - y), this.width, this.height)
				if (!array) return

				ctx.strokeStyle = '#3184ff'
				ctx.lineWidth = 1

				//比例系数
				var sc = (this.width / this.length) * this.hex

				ctx.beginPath()
				array.forEach(value => {
					var px = parseInt(((value / this.hex) * sc).toFixed(0))
					ctx.moveTo(px + 0.5, y - 1.5)
					ctx.lineTo(px + 0.5, y - 31 + 0.5)
				})
				ctx.stroke()
			},
			/**
			 * 绘制标尺。
			 */
			drawHorizontalAxisTicks() {
				//小刻度长度的临时变量
				var deltaY
				var tickHeight = 10

				var horizontal_tick_spacing = (this.width / this.length) * this.hex
				var horizontal_ticks = this.width / horizontal_tick_spacing
				//数字与坐标轴的距离
				var space_between_labels_and_axis = 8
				var axis_origin = {
					x: 0,
					y: this.height / 1.6,
				}

				var context = this.canvas.getContext('2d')
				context.strokeStyle = '#8bff65'
				context.lineWidth = 1

				console.log(horizontal_ticks)

				var step = 10
				if (horizontal_ticks >= 500 && horizontal_ticks < 5000) {
					step = 500
				} else if (horizontal_ticks >= 5000 && horizontal_ticks < 20000) {
					step = 200
				} else if (horizontal_ticks >= 20000 && horizontal_ticks < 50000) {
					step = 5000
				} else if (horizontal_ticks >= 50000 && horizontal_ticks < 500000) {
					step = 10000
				} else if (horizontal_ticks >= 500000) {
					step = 100000
				}
				for (var i = 1; i < horizontal_ticks; ++i) {
					//每10个刻度为长的小刻度
					if (i % step === 0) {
						context.beginPath()
						deltaY = tickHeight

						console.log('i%step=0', i)

						context.moveTo(axis_origin.x + i * horizontal_tick_spacing + 0.5, axis_origin.y + deltaY + 0.5)
						context.lineTo(axis_origin.x + i * horizontal_tick_spacing + 0.5, axis_origin.y + 0.5)
						context.stroke()
					} else {
						deltaY = tickHeight * 0.3
					}
				}

				context.fillStyle = '#8bff65'
				context.textAlign = 'center'
				context.textBaseline = 'top'
				// 添加横坐标数字标签
				for (let i = 0; i <= horizontal_ticks; ++i) {
					if (i % step === 0 && i > 0) {
						context.fillText(i + 'm', axis_origin.x + i * horizontal_tick_spacing + 13, axis_origin.y + space_between_labels_and_axis)
					}
				}

				//绘制开头和结束的字符。
				context.textAlign = 'left'
				context.fillText('卷起点：0m', 0, axis_origin.y + space_between_labels_and_axis)

				context.textAlign = 'right'
				context.fillText('卷终点：' + (this.length / this.hex).toFixed(0) + 'm', this.width, axis_origin.y + space_between_labels_and_axis)
			},
		},
		mounted() {
			this.canvas = this.$refs.ruleCanvas
		},
	}
</script>

<style></style>
